export default "__VITE_ASSET__Bb2tsn6I__"